"use strict";

exports.__esModule = true;

var _core = require("./core");

Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  exports[key] = _core[key];
});

var _react = require("./react");

Object.keys(_react).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  exports[key] = _react[key];
});


//////////////////
// WEBPACK FOOTER
// ./~/react-query/lib/index.js
// module id = 399
// module chunks = 0